export default __webpack_public_path__ + "static/media/screen6.4a7674ed.png";